import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState
} from "react";

const DashboardContext = createContext(null);

export const DashboardProvider = ({ children }) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  const [mobileSidebarOpen, setMobileSidebarOpen] =
    useState(false);

  const [pageTitle, setPageTitle] =
    useState("Dashboard");

  useEffect(() => {
  setPageTitle("Dashboard");
}, []);

  const toggleSidebar = useCallback(() => {
    setSidebarCollapsed((prev) => !prev);
  }, []);

  const openMobileSidebar = useCallback(() => {
    setMobileSidebarOpen(true);
  }, []);

  const closeMobileSidebar = useCallback(() => {
    setMobileSidebarOpen(false);
  }, []);

  const value = useMemo(
    () => ({
      sidebarCollapsed,
      setSidebarCollapsed,

      toggleSidebar,

      mobileSidebarOpen,
      setMobileSidebarOpen,

      openMobileSidebar,
      closeMobileSidebar,

      pageTitle,
      setPageTitle,
    }),
    [
      sidebarCollapsed,
      mobileSidebarOpen,
      pageTitle,
      toggleSidebar,
      openMobileSidebar,
      closeMobileSidebar,
    ]
  );

  return (
    <DashboardContext.Provider value={value}>
      {children}
    </DashboardContext.Provider>
  );
};

export const useDashboard = () => {
  const context = useContext(DashboardContext);

  if (!context) {
    throw new Error(
      "useDashboard must be used inside DashboardProvider"
    );
  }

  return context;
};
